import React from 'react';
import { Star } from 'lucide-react';
const StarRating = ({
  rating,
  colorClass
}: {
  rating: number;
  colorClass: string;
}) => {
  return <div className="flex items-center gap-1" data-id="element-93">
      {[1, 2, 3, 4, 5].map(star => <div key={star} className="relative" data-id="element-94">
          <Star className={`w-5 h-5 sm:w-6 sm:h-6 text-gray-200 fill-gray-200`} data-id="element-95" />
          {rating >= star && <Star className={`w-5 h-5 sm:w-6 sm:h-6 absolute top-0 left-0 ${colorClass} fill-current`} data-id="element-96" />}
          {rating > star - 1 && rating < star && <div className="absolute top-0 left-0 overflow-hidden w-[50%]" data-id="element-97">
              <Star className={`w-5 h-5 sm:w-6 sm:h-6 ${colorClass} fill-current`} data-id="element-98" />
            </div>}
        </div>)}
    </div>;
};
export function TrustBadges() {
  return <section className="w-full py-8 bg-gray-50/50 border-y border-gray-100" data-id="element-99">
      <div className="max-w-6xl mx-auto px-4" data-id="element-100">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-4 items-center justify-items-center text-center" data-id="element-101">
          {/* Google */}
          <div className="flex flex-col items-center space-y-3" data-id="element-102">
            <div className="text-3xl sm:text-4xl font-bold tracking-tighter flex items-center" data-id="element-103">
              <span className="text-[#4285F4]" data-id="element-104">G</span>
              <span className="text-[#EA4335]" data-id="element-105">o</span>
              <span className="text-[#FBBC05]" data-id="element-106">o</span>
              <span className="text-[#4285F4]" data-id="element-107">g</span>
              <span className="text-[#34A853]" data-id="element-108">l</span>
              <span className="text-[#EA4335]" data-id="element-109">e</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-110">
              <StarRating rating={4.8} colorClass="text-[#FBBC05]" data-id="element-111" />
              <span className="text-xl font-bold text-gray-800" data-id="element-112">4.8</span>
            </div>
            <p className="text-sm text-gray-500 font-medium" data-id="element-113">
              Based On 22,000+ Reviews
            </p>
          </div>

          {/* ConsumerAffairs */}
          <div className="flex flex-col items-center space-y-3" data-id="element-114">
            <div className="text-2xl sm:text-3xl font-extrabold tracking-tight text-black" data-id="element-115">
              ConsumerAffairs
            </div>
            <div className="flex items-center gap-3" data-id="element-116">
              <StarRating rating={4.6} colorClass="text-[#FBBC05]" data-id="element-117" />
              <span className="text-xl font-bold text-gray-800" data-id="element-118">4.6</span>
            </div>
            <p className="text-sm text-gray-500 font-medium" data-id="element-119">
              Based On 18,500+ Reviews
            </p>
          </div>

          {/* Trustpilot */}
          <div className="flex flex-col items-center space-y-3" data-id="element-120">
            <div className="flex items-center gap-2 text-2xl sm:text-3xl font-extrabold tracking-tight text-black" data-id="element-121">
              <div className="bg-[#00B67A] p-1 rounded-sm" data-id="element-122">
                <Star className="w-6 h-6 text-white fill-white" data-id="element-123" />
              </div>
              Trustpilot
            </div>
            <div className="flex items-center gap-3" data-id="element-124">
              <StarRating rating={4.9} colorClass="text-[#00B67A]" data-id="element-125" />
              <span className="text-xl font-bold text-gray-800" data-id="element-126">4.9</span>
            </div>
            <p className="text-sm text-gray-500 font-medium" data-id="element-127">
              Based On 31,000+ Reviews
            </p>
          </div>
        </div>
      </div>
    </section>;
}